import { TypographyP } from '@talentmesh/ui/components/typography';
import JobAdLabel from './JobAdLabel';
import UIStrings from '@/Utils/UIStrings';

function JobAdExplanation() {
    return (
        <div className="flex flex-col gap-2">
            <JobAdLabel label={UIStrings.ProvideInformationForTheJobDescription} />
            <TypographyP className="text-foreground">{UIStrings.DescribeTheJob}</TypographyP>
        </div>
    );
}

export default JobAdExplanation;
